import { render } from "./Page-Section.vue?vue&type=template&id=4938aa78"
import script from "./Page-Section.vue?vue&type=script&lang=js"
export * from "./Page-Section.vue?vue&type=script&lang=js"

import "./Page-Section.vue?vue&type=style&index=0&id=4938aa78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__